import { IGazeAdapter, GazePoint } from "./IGazeAdapter";

export class WebGazeAdapter implements IGazeAdapter {
  private scene: Phaser.Scene;
  private point: GazePoint = { x: 0, y: 0 };

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  start(): void {
    this.scene.input.on("pointermove", (pointer: Phaser.Input.Pointer) => {
      this.point.x = pointer.x;
      this.point.y = pointer.y;
    });
  }

  stop(): void {
    this.scene.input.off("pointermove");
  }

  getGazePoint(): GazePoint {
    return this.point;
  }
}
